/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button, Box, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";

import SearchBar from "../../components/SearchBar";
import AddUser from "../../Modals/addUser";
import { isValidInput } from "../../utils/validations";
import { RoleTypes } from "types/General";

const UserListFilter = ({
  handleProfileUpload,
  roles,
  handleSubmit,
  name,
  setName,
  email,
  setEmail,
  phone,
  handleChangePhone,
  dialCode,
  setDialCode,
  selectedRole,
  setSelectedRole,
  selectedImage,
  setSelectedImage,
  onClose,
  debouncedSearchTerm,
  setDebouncedSearchTerm,
  page,
  setPage,
  loading,
  setLoading,
}: any) => {
  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  const [anchorEl2, setAnchorEl2] = React.useState<null | HTMLElement>(null);
  const open2 = Boolean(anchorEl2);
  const handleClick2 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  const dummyRoles: RoleTypes[] = [
    {
      _id: "1",
      name: "Admin",
      permission: [
        {
          sideBarId: 101,
          label: "Dashboard",
          isView: true,
          isAdd: true,
          isEdit: true,
          isDelete: true,
        },
        {
          sideBarId: 102,
          label: "Users",
          isView: true,
          isAdd: true,
          isEdit: true,
          isDelete: true,
        },
      ],
    },
    {
      _id: "2",
      name: "Manager",
      permission: [
        {
          sideBarId: 101,
          label: "Dashboard",
          isView: true,
          isAdd: false,
          isEdit: false,
          isDelete: false,
        },
        {
          sideBarId: 103,
          label: "Reports",
          isView: true,
          isAdd: false,
          isEdit: true,
          isDelete: false,
        },
      ],
    },
    {
      _id: "3",
      name: "Viewer",
      permission: [
        {
          sideBarId: 101,
          label: "Dashboard",
          isView: true,
          isAdd: false,
          isEdit: false,
          isDelete: false,
        },
        {
          sideBarId: 104,
          label: "Settings",
          isView: false,
          isAdd: false,
          isEdit: false,
          isDelete: false,
        },
      ],
    },
  ];

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <SearchBar
            searchTerm={searchTerm}
            setDebouncedSearchTerm={setDebouncedSearchTerm}
            value={searchTerm}
            onCross={() => setSearchTerm("")}
            onChange={(val: any) => {
              if (isValidInput(val.target.value)) {
                setSearchTerm(val.target.value);
              }
            }}
            placeholder={""}
          />
        </div>
        <div className="right_s">
          {/* <Box>
            <Button
              className="btn btn_highlight"
              aria-controls={open1 ? "basic-menu1" : undefined}
              aria-haspopup="true"
              aria-expanded={open1 ? "true" : undefined}
              onClick={handleClick1}
            >
              <img src="/static/images/filter_icon.svg" alt="Icon" /> Filter
            </Button>
            <Menu
              className="filter_menu"
              id="basic-menu1"
              anchorEl={anchorEl1}
              open={open1}
              onClose={handleClose1}
              MenuListProps={{
                "aria-labelledby": "basic-button2",
              }}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  boxShadow: "0px 4px 30px 0px rgba(0, 0, 0, 0.13)",
                  borderRadius: "10px",
                  mt: 1,
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <MenuItem className="export_btns v2">
                <Button>
                  <span className="round c_success"></span> Enabled
                </Button>
                <Button>
                  <span className="round c_grey"></span> Pending
                </Button>
                <Button>
                  <span className="round c_warning"></span> Disabled
                </Button>
                <Button>
                  <span className="round c_danger"></span> Blocked
                </Button>
              </MenuItem>
            </Menu>
          </Box> */}
          <Box>
            <Button
              className="btn btn_highlight"
              aria-controls={open2 ? "basic-menu2" : undefined}
              aria-haspopup="true"
              aria-expanded={open2 ? "true" : undefined}
              // onClick={handleClick2}
            >
              <img src="/static/images/upload_icon.svg" alt="Icon" /> Export CSV
            </Button>
            <Menu
              className="filter_menu"
              id="basic-menu2"
              anchorEl={anchorEl2}
              open={open2}
              onClose={handleClose2}
              MenuListProps={{
                "aria-labelledby": "basic-button2",
              }}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  boxShadow: "0px 4px 30px 0px rgba(0, 0, 0, 0.13)",
                  borderRadius: "10px",
                  mt: 1,
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <MenuItem className="export_btns v2">
                {/* <Button>PDF</Button> */}
                <Button>CSV</Button>
                {/* <Button>Excell</Button>
                <Button>Zip</Button>
                <Button>Text</Button> */}
              </MenuItem>
            </Menu>
          </Box>
          <Button
            className="btn btn_secondary"
            onClick={() => setOpenModal(true)}
          >
            Add Sub Admin
          </Button>
        </div>
      </div>

      <AddUser
        handleProfileUpload={handleProfileUpload}
        selectedImage={selectedImage}
        setSelectedImage={setSelectedImage}
        roles={dummyRoles}
        handleSubmit={handleSubmit}
        setOpenModal={setOpenModal}
        onClose={onClose}
        setOpen={setOpenModal}
        name={name}
        setName={setName}
        email={email}
        setEmail={setEmail}
        phone={phone}
        handleChangePhone={handleChangePhone}
        dialCode={dialCode}
        setDialCode={setDialCode}
        setSelectedRole={setSelectedRole}
        selectedRole={selectedRole}
        closeSubmit={onClose}
        open={openModal}
        loading={loading}
        setLoading={setLoading}
      />
    </>
  );
};

export default UserListFilter;
